import React, { useState } from 'react';
import {
  Col,
  Input,
  Row,
  Select,
  Radio,
  Button,
  Space,
  Typography,
  Switch,
} from 'antd';

const { Paragraph } = Typography;

function Security({ Form }) {
  const [size, setSize] = useState();

  const onChange = (checked) => {
    console.log(`switch to ${checked}`);
  };
  return (
    <>
      <Row gutter={[16, 0]}>
        <Col sm={24} md={24}>
          <Form.Item
            label=" Current Password"
            name="password"
            rules={[
              {
                required: true,
                message: ' Current Password is required',
              },
            ]}
          >
            <Input type="password" autoFocus />
          </Form.Item>
        </Col>
        <Col sm={24} md={24}>
          <Form.Item
            label="New Password"
            name="new password"
            rules={[
              {
                required: true,
                message: 'New Password is required',
              },
            ]}
          >
            <Input type="password" autoFocus />
          </Form.Item>
        </Col>
        <Col sm={24} md={24}>
          <Form.Item
            label="Confirm Password"
            name="confirm password"
            rules={[
              {
                required: true,
                message: 'Confirm Password" is required',
              },
            ]}
          >
            <Input type="password" autoFocus />8 characters or longer .Combine
            Uppercase and lowercase letters and numbers.
          </Form.Item>
        </Col>

        <Col sm={24} md={22}>
          <Typography.Title
            level={4}
            style={{
              margin: 0,
            }}
          >
            Two-Factor-Authentication
            <Paragraph>
              Recommended.We will send an authentication code via sms or email.
            </Paragraph>
          </Typography.Title>
        </Col>
        <Col sm={24} md={2}>
          <Switch defaultChecked={false} onChange={onChange} />
        </Col>
      </Row>
      <br />
      <Space wrap>
        <Button size={size}>Cancel</Button>
        <Button type="primary" size={size}>
          Update Info
        </Button>
      </Space>
    </>
  );
}

export default Security;
